import React, { useState, useRef } from 'react';
import styles from './CheckoutCode.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import Tooltip from '../../../../ui_kit/tooltip/Tooltip';

export const COUPON_CODE = 'LOVEVB';

function CheckoutCode() {
  const [codeCopied, setCodeCopied] = useState(false);
  const codeRef = useRef(null);

  return (
    <div className={styles['checkout-code']}>
      Use code
      {' '}
      <ClickableDiv
        className={styles.code}
        onClick={() => {
          codeRef.current.select();
          document.execCommand('copy');
          setCodeCopied(true);
          setTimeout(() => {
            setCodeCopied(false);
          }, 3000);
        }}
      >
        {COUPON_CODE}
        { codeCopied && (
          <Tooltip className={styles.tooltip} type="info">
            Code copied
          </Tooltip>
        )}
      </ClickableDiv>
      {' '}
      at checkout for 20% off your purchase!
      <input
        type="text"
        readOnly
        style={{ position: 'absolute', left: '-99999px' }}
        ref={codeRef}
        value={COUPON_CODE}
      />
    </div>
  );
}

export default CheckoutCode;
